import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description: string;
  keywords?: string;
  jsonLd?: Record<string, unknown>[];
}

export function useSeo({ title, description, keywords, jsonLd }: SeoOptions) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", description);
    if (keywords) setMeta("keywords", keywords);

    // 清理旧 JSON-LD，注入新的结构化数据
    document
      .querySelectorAll("script[data-seo-jsonld]")
      .forEach((n) => n.remove());
    if (jsonLd && jsonLd.length) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo-jsonld", "true");
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }

    return () => {
      document
        .querySelectorAll("script[data-seo-jsonld]")
        .forEach((n) => n.remove());
    };
  }, [title, description, keywords, JSON.stringify(jsonLd)]);
}